import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[650px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-background-50">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20golden%20and%20deep%20crimson%20gradient%2C%20film%20reel%20texture%20overlay%2C%20elegant%20movie%20theater%20atmosphere%2C%20dramatic%20lighting%20with%20lens%20flare%2C%20luxurious%20dark%20background%20with%20warm%20accents%2C%20cinematic%20widescreen%20aesthetic&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="2828电影网 - 免费电视剧在线观看平台主视觉背景"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium tracking-wide mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-3">
              {heroData.title}
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-background-50/90 font-heading mb-6">
              {heroData.subtitle}
            </p>

            <p className="text-sm md:text-base text-background-50/75 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 font-medium rounded-full text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/30 to-accent-500/30 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20collection%20of%20Chinese%20drama%20and%20movie%20poster%20artworks%20floating%20in%20artistic%20arrangement%2C%20warm%20golden%20and%20crimson%20gradient%20background%2C%20soft%20glowing%20particles%2C%20cinematic%20composition%2C%20premium%20streaming%20platform%20visual%2C%20rich%20contrast%20and%20depth&width=800&height=1000&seq=hero-visual&orientation=portrait"
                alt="2828电影网热门电视剧海报精选合集"
                className="relative w-full h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}